<template>
  <div class="tips modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title">Consejos y Ayuda para ProgramaLaPlaza</p>
    </header>

    <section class="modal-card-body">
      <div id = "1" class = "content">
        <h2>Introducción</h2>
        <p>Medialab-Prado es un centro del departamento de Arte del Ayuntamiento de Madrid enfocado a la producción, investigación y diseminación de la cultura digital, donde el arte, la ciencia, la tecnología y la sociedad interseccionan. Está ubicado en el distrito de las artes, en pleno centro de Madrid.</p>
        <img src="/static/img/tips/mlp_inside.jpg" alt="Mlp Inside" />
        <p>
         Uno de los laterales del Medialab-Prado está cubierto por 30144 LEDs de gran tamaño, convirtiendola en una fachada digital bastante imponente y característica. La fachada da hacia una plaza donde mucha gente suele pasar y que se convierte en espacio de interacción con la fachada.
         La fachada digital del Medialab-Prado está destinada para usos culturales que son vistos por miles de personas diariamente.
       </p>
       <a href = "https://www.openstreetmap.org/?mlat=40.41062&mlon=-3.69368#map=18/40.41082/-3.69438" target="_blank">
         <img src="/static/img/tips/mlp_location.png"/>
       </a>
      </div>

      <div id = "2" class = "content">
        <h2>Gran tamaño, baja resolución</h2>
        <p> La fachada tiene unas dimensiones de 15x10 metros, lo que la hace de un tamaño bastante considerable. Sin embargo su resolución es bastante baja, sólo 192x157 pixels.
          La forma característica de la fachada, el tamaño de LEDs y el numero limitado de pixels, son varias características a tener en cuenta a la hora de crear tu proyecto. Todo se verá bastante único en la pantalla :)
        </p>
        <p> <a href = "https://www.medialab-prado.es/noticias/fachada-digital-informacion-tecnica-0" > Más información técnica</a> </p>
        <div class = "columns">
          <img src="/static/img/tips/mlp_building.png" alt="Mlp Building" />
          <img src="/static/img/tips/mlp_screen_details.png" alt="Mlp Screen Details" />
        </div>
      </div>

      <div id = "3" class = "content">
        <h2>P5js, Processing.js, Threejs, Canvas</h2>
        <p> Actualmente la plataforma soporta estás cuatro maneras de trabajar.
        <ul>
          <li><a href = "https://p5js.org">p5.js</a> Versión web de Processing</li>
          <li><a href = "http://www.processingjs.org"> Processing.js </a> Antigua versión web de Processing</li>
          <li><a href = "http://threejs.org">Three.js</a></li>
          <li>HTML5 canvas para los más aventureros</li>
        </ul>
        </p>
        <p>Se programa utilizando el editor web, y todos los modos incluyen ejemplos básicos de cómo interactuar con las funciones de seguimiento de personas y otras de la fachada</p>
      </div>

      <div id = "4" class = "content">
        <h2>Consejos de uso de color</h2>
        <p>El Medialab-Prado está localizado en el centro de la ciudad, muchos miles de personas pasan por delante de la fachada cada día e incluso mucha gente vive junto al edificio.
          Por eso recomendamos que tus proyectos tengan colores "amigables" y no usen animaciones demasiado abruptas. Cuanto más suave, mejor se verá en la pantalla y a la gente le gustará más
        </p>
        <img src = "/static/img/tips/mlp_eyeattack.png" style = "border:0"/>
      </div>

      <div id = "5" class = "content">
        <h2> Interación - Seguimiento de Personas </h2>
        <p> Encima del edificio de Medialab-Prado, tenemos una camara CCTV que mira hacia la plaza para poder hacer seguimiento de personas y que tus proyectos puedan convertirse en interactivos.</p>
        <p> Nuestro sistema hace toda la parte del tracking, en tu proyecto, con una sola línea de código puedes saber cuantas personas están en la plaza y seguir sus movimiendos mediante <a href = "http://en.wikipedia.org/wiki/Blob_detection">blobs</a></p>
        <p> Para empezar dirígete a la sección de ejemplos y elige Tracking para ver como funciona. </p>
        <img src="/static/img/tips/mlp_cameras.png" alt="Mpl Phones" />
        <p> Nota: El video que proviene de la cámara no se graba sólo se utiiza únicamente para fines artísticos.</p>
      </div>

      <!--
      <div id = "6" class = "content">
        <h2> Interaction - Phones </h2>
        <p> People standing in front of the Media Facade can have a one-button interaction between your sketch and their mobile devices. They will be able to interact just accessing a web url displayed on the building while your sketch is running. </p>
        <p>Check out the Phone Interaction EXAMPLE for more details</p>
        <img src="/static/img/tips/mlp_phones.png" width="500" height="378" alt="Mpl Cameras" style = "border:0">
      </div>
      -->

      <div id = "7" class = "content">
        <h2> Responsabilidad </h2>
        <p>El usuario es el único responsable del contenido que publique. Medialab-Prado se reserva el derecho de borrar contenidos y/o usuarios cuando estos no respeten los fines del presente foro.</p>
        <p>No se aceptará bajo ningún concepto cualquier contenido que atente contra las leyes, o contra el honor o intimidad de las personas, produciéndose su borrado desde el mismo momento en que se tenga conocimiento del mismo.</p>
        <p>Si por cualquier circunstancia entiende usted que el contenido viola alguna de las anteriores cuestiones, le rogamos se ponga inmediatamente en contacto con el administrador del foro en la siguiente dirección de correo electrónico: info.m@medialab-prado.es </p>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'EditorTips',
  components: {
  },
  props: {
    project: Object
  }
}
</script>

<style lang = "less" scoped>
@import (reference) "../../assets/styles/main.less";

.modal-card {
  max-height: 60vh;
}

.content {
  margin-bottom: 5em;

  h2 {
    color: @accentColor;
  }
}

img {
  width: 100%;
  margin: 20px 0;
}

.columns {
  img {
    align-self: center;
    min-width: 0;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Editor/EditorTips.vue